import { Heading, Icon, Span, type UiIconNames } from "@icg360/design-system";

import { formatCurrency } from "utils";

import styles from "./commercial-deductibles.module.scss";

export const CommercialDeductibles = ({ data }) => {
  const { currentTerm } = data?.userDetails ?? {
    currentTerm: {},
  };
  const {
    propertyDamageLiabilityDeductiblePerClaim: propertyPerClaim,
    propertyDamageLiabilityDeductiblePerOccurrence: propertyPerOcc,
    termLocationData,
  } = currentTerm ?? {};

  const locationData = termLocationData?.find((loc) => loc?.location === 1);
  let allOtherPerilsDeductible = "N/A",
    hurricane = "N/A",
    windHail = "N/A";

  if (locationData) {
    hurricane = locationData?.hurricaneDeductible ?? "N/A";
    allOtherPerilsDeductible = locationData?.allOtherPerilsDeductible ?? "N/A";
    windHail = locationData?.windHailDeductible ?? "N/A";
  }

  let propertyDamageDeductible = "N/A";
  let labelInfo = "";

  if (propertyPerClaim) {
    propertyDamageDeductible = formatCurrency(
      (parseInt(propertyPerClaim, 10) * 100).toString()
    );
    labelInfo = " (per claim)";
  } else if (propertyPerOcc) {
    propertyDamageDeductible = formatCurrency(
      (parseInt(propertyPerOcc, 10) * 100).toString()
    );
    labelInfo = " (per occurrence)";
  }

  const deductibleMap = [
    {
      icon: "LossHistory",
      label: "All other perils",
      details:
        "The amount you pay before coverage begins, separate from a hurricane, windstorm, or hail deductible.",
      value: allOtherPerilsDeductible,
    },
    {
      icon: "StormCloud",
      label: "Wind/Hail",
      details:
        "The amount you pay for damage from wind or hail before your coverage kicks in.",
      value: windHail,
    },
    {
      icon: "Hurricane",
      label: "Hurricane",
      details:
        "Coverage for your belongings that aren't attached to your home, like furniture and clothing.",
      value: hurricane,
    },
    {
      icon: "HouseShield",
      label: "Property Damage" + labelInfo,
      details:
        "The amount you pay out of pocket for property damage liability claims before your insurance coverage starts.",
      value: propertyDamageDeductible,
    },
  ];

  return deductibleMap?.map(
    (deductible: {
      icon: UiIconNames;
      label: string;
      details: string;
      value: string;
    }) => (
      <div className={styles.deductibleItemHeader} key={deductible.label}>
        <div className={styles.deductibleIcon}>
          <Icon name={deductible.icon} size="lg" />
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <Heading size="xs">{deductible.label}</Heading>
            <Span color="quiet">{deductible.details}</Span>
          </div>
          <div className={styles.valueDS}>
            <Span bold>{deductible.value}</Span>
          </div>
        </div>
      </div>
    )
  );
};
